export default "__VITE_ASSET__92f5fbe4__"